import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Box from '@mui/material/Box';
import { Alert, Button } from '@leapeasy/ui-kit';

import { setDataAction } from 'store/actions/claimFormActions';

import styled from '@emotion/styled';

const FormComments = (props) => {
  const { actions, formData, handleNext, handleBack } = props;

  const [content, setContent] = useState('');

  useEffect(() => {
    formData && formData.data.additional_comment && setContent(formData.data.additional_comment);
  }, [formData]);

  const handleNextButton = () => {
    actions.setDataAction({
      ...formData.data,
      additional_comment: content,
    });
    handleNext();
  };

  return (
    <Fragment>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'row',
          mt: 4,
          gap: '16px',
          flexDirection: 'column',
        }}
      >
        <CustomTextarea>
          <span className="label">
            Additional Comments <span className="optional">(Optional)</span>
          </span>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Enter any additional details or special instructions for the adjuster..."
          />
          <span className="helper">
            Use this field for special instructions or any additional details you'd like to share
            with the adjuster.
          </span>
        </CustomTextarea>

        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '10px',
          }}
        >
          <Button size="medium" variant="secondary" onClick={handleBack} style={{ flexShrink: 2 }}>
            Back
          </Button>

          <Button
            size="medium"
            variant="primary"
            onClick={handleNextButton}
            style={{ flexShrink: 1 }}
          >
            Next
          </Button>
        </Box>

        <Alert
          showIcon
          showClose={false}
          showBorder={false}
          type="info"
          variant="contained"
          description={`Provide supplementary claim details, additional contact information, and add context you missed.`}
        />
      </Box>
    </Fragment>
  );
};

const CustomTextarea = styled.div`
  width: 100%;
  margin-top: 20px;
  color: #6a5e71;

  span {
    color: #6a5e71;
    font-size: 10px;
  }

  span.optional {
    font-size: 10px;
    color: #9e9e9e;
    font-style: italic;
  }

  span.helper {
    display: block;
    margin-top: 6px;
    font-size: 11px;
    color: #9e9e9e;
  }
  & > textarea {
    width: 100%;
    border: 1px solid #e1e1e1;
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 14px;
    min-height: 150px;
  }

  & > textarea:focus {
    outline: none;
    border: 1px solid #90388b;
  }
`;

const mapStateToProps = (state) => {
  return {
    formData: state.getIn(['formData']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        setDataAction,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormComments);
